resourcePaths = '{"rootPath":"/member","assetsPath":"/member/assets"}';function InputPhone() {
  this.extends = [InputText];
  this.node = null;
  this.id = null;

  // Properties
  this.placeholder = "(000) 000-0000";
  this.error = "";
  this.maxLength = 10;

  // use jquery plugin mask for desktop/ios if the user is on IE or Android use a fallback on change
  this.mask = {
    format: '(999) 999-9999',
    placeholder: '  ',
    add: function(value) { return this._addMaskCallback(value); }.bind(this), // fallback mask
    remove: function(value) { return this._removeMaskCallback(value); }.bind(this) // fallback unmask
  };


  this.init = function() {
    // Classes
    this._classes = $.extend(this._classes, {
      phone: 'input-phone',
    });

    // increase max length if maskOnBlur to allow the user to temporaily
    // add spaces to their input
    this._initMaxLength = this.maxLength;
    if (this.maskOnBlur) {
      this.maxLength += 2;
    }

    // Setup
    this._super();
    this.containerDiv.addClass(this._classes.phone);
  };

  this.initAllReady = function() {};

  this.destroy = function() {
    this._super();
  };


  this._addMaskCallback = function(value) {
    // cleanup input before masking
    value = String(value).replace(/\D/g, '').substring(0, this._initMaxLength);

    // if the is no value dont add a mask
    if (value.length <= 0) return value;

    // convert the value to an array and fill it with empty spaces
    value = value.split('');
    var emptySpaces = new Array((this.maxLength + 3) - value.length);
    //to do this we would use fill but on Samsung Native Browsers this is not available
    for (var i = 0; i < emptySpaces.length; i++) { emptySpaces[i] = ' '; }
    value.concat(emptySpaces);

    // add first area code bracket
    value.unshift('(');

    // add second area code bracket
    if (value[4] === ' ') value.splice(4, 1, ')');
    else value.splice(4, 0, ')');

    // add space after area code bracket
    if( value[5] !== ' ') value.splice(5, 0, ' ');

    // add spacing - between 999 and 9999
    if( value[9] === ' ') value.splice(9, 1, '-');
    else value.splice(9, 0, '-');

    // return a string
    return value.join('');
  };

  this._removeMaskCallback = function(value) {
    // remove all non-integers then remove any characters over inital maxLength
    return value.replace(/\D/g, '').substring(0, this._initMaxLength);
  };

}
